var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncIconBlackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V2.21C12 1.76 11.46 1.54 11.15 1.86L8.35 4.65C8.15 4.85 8.15 5.16 8.35 5.36L11.14 8.15C11.46 8.46 12 8.24 12 7.79V6C15.31 6 18 8.69 18 12C18 12.79 17.85 13.56 17.56 14.25C17.41 14.61 17.52 15.02 17.79 15.29C18.3 15.8 19.16 15.62 19.43 14.95C19.8 14.04 20 13.04 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 11.21 6.15 10.44 6.44 9.75C6.59 9.39 6.48 8.98 6.21 8.71C5.7 8.2 4.84 8.38 4.57 9.05C4.2 9.96 4 10.96 4 12C4 16.42 7.58 20 12 20V21.79C12 22.24 12.54 22.46 12.85 22.14L15.64 19.35C15.84 19.15 15.84 18.84 15.64 18.64L12.85 15.85C12.54 15.54 12 15.76 12 16.21V18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIconBlackWhite);
export default __webpack_public_path__ + "static/media/sync-icon-black-white.a01e97250ab8b78fde33f0aa7ae582d7.svg";
export { ForwardRef as ReactComponent };